__turbopack_context__.v({
  "active": "HighlightNavigation-module-scss-module__GjDpzq__active",
  "hidden": "HighlightNavigation-module-scss-module__GjDpzq__hidden",
  "highlightNavigation": "HighlightNavigation-module-scss-module__GjDpzq__highlightNavigation",
  "link": "HighlightNavigation-module-scss-module__GjDpzq__link",
});
